export default __webpack_public_path__ + "static/logo-c647ea44b9618c850302aee0daf0c7e1.png";